import React, { Dispatch, useContext } from 'react';
import { FormControl, IconButton, InputAdornment, OutlinedInput } from '@mui/material';
import {
  Send as SendIcon,
} from '@mui/icons-material';
import PersonService from 'services/person';
import UserContext from 'shared/contexts/UserContext';
import S3Avatar from './S3Avatar';

const { fullname, initials } = PersonService;

interface Props {
  comment: string;
  disabled?: boolean;
  placeholder?: string;
  handleComment: () => void;
  isSubmitting: boolean;
  noSubmit?: boolean;
  setComment: Dispatch<string>;
}

const CommentInput: React.FC<Props> = ({
  comment,
  disabled,
  placeholder,
  handleComment,
  isSubmitting,
  noSubmit,
  setComment,
}: Props) => {
  const [userState] = useContext(UserContext);
  const { person } = userState;

  return (
    <>
      <FormControl
        variant="standard"
        sx={{
          width: '100%',
          marginBottom: '0.75rem',
          ...(isSubmitting && { '& textarea': { opacity: '0.6' } }),
        }}
      >
        <OutlinedInput
          sx={(t) => ({
            backgroundColor: t.palette.grey1,
            '& .MuiOutlinedInput-notchedOutline': {
              border: `1px solid ${t.palette.grey3}`,
            },
          })}
          multiline
          disabled={disabled || isSubmitting}
          placeholder={placeholder || 'Add a Comment'}
          value={comment}
          maxRows={10}
          inputProps={{ maxLength: 350 }}
          onChange={(event) => setComment(event.target.value)}
          startAdornment={(
            <InputAdornment position="start">
              <S3Avatar picture={person.avatar} alt={fullname(person)} title={fullname(person)}>
                {initials(person)}
              </S3Avatar>
            </InputAdornment>
          )}
          endAdornment={noSubmit ? null : (
            <InputAdornment position="end">
              <IconButton onClick={handleComment} disabled={!comment?.trim()} size="large">
                <SendIcon />
              </IconButton>
            </InputAdornment>
          )}
        />
      </FormControl>
    </>
  );
};

export default CommentInput;
